
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 3.063c4.54 0 5.077.017 6.87.1 1.657.075 2.557.352 3.156.585.794.308 1.36.676 1.955 1.271a5.266 5.266 0 011.271 1.955c.233.599.51 1.5.586 3.157.082 1.792.099 2.33.099 6.87 0 4.538-.017 5.076-.1 6.869-.075 1.657-.352 2.557-.584 3.156a5.265 5.265 0 01-1.272 1.955 5.268 5.268 0 01-1.955 1.272c-.599.232-1.499.51-3.157.585-1.792.082-2.33.1-6.869.1-4.54 0-5.077-.018-6.87-.1-1.657-.076-2.557-.353-3.156-.585a5.267 5.267 0 01-1.955-1.272 5.267 5.267 0 01-1.271-1.955c-.233-.599-.51-1.499-.586-3.156-.082-1.793-.099-2.33-.099-6.87s.017-5.077.1-6.87c.075-1.657.352-2.557.585-3.156a5.266 5.266 0 011.271-1.955 5.268 5.268 0 011.955-1.271c.599-.233 1.5-.51 3.157-.586 1.792-.082 2.33-.099 6.87-.099zM17 0c-4.617 0-5.196.02-7.009.102-1.81.083-3.045.37-4.127.79a8.333 8.333 0 00-3.01 1.961A8.334 8.334 0 00.892 5.864C.473 6.946.185 8.181.103 9.991.02 11.804 0 12.383 0 17c0 4.616.02 5.195.102 7.008.083 1.81.37 3.045.79 4.127a8.332 8.332 0 001.961 3.01 8.334 8.334 0 003.011 1.962c1.082.42 2.317.707 4.127.79C11.804 33.98 12.383 34 17 34c4.617 0 5.196-.02 7.01-.102 1.809-.083 3.044-.37 4.126-.79a8.334 8.334 0 003.01-1.961 8.333 8.333 0 001.962-3.011c.42-1.082.707-2.317.79-4.127C33.98 22.196 34 21.617 34 17c0-4.617-.02-5.196-.102-7.009-.083-1.81-.37-3.045-.79-4.127a8.333 8.333 0 00-1.961-3.01A8.333 8.333 0 0028.136.892c-1.082-.42-2.317-.708-4.127-.79C22.196.02 21.617 0 17 0zm0 8.27a8.73 8.73 0 100 17.46 8.73 8.73 0 000-17.46zm0 14.397a5.667 5.667 0 110-11.334 5.667 5.667 0 010 11.334z","fill":"#000"}}),_c('path',{attrs:{"d":"M26.075 9.965a2.04 2.04 0 100-4.08 2.04 2.04 0 000 4.08z","fill":"#000"}})])
          )
        }
      }
    